module.exports = __webpack_public_path__ + "070b2a303865746d6ae27041d1d3ad51.png";